export default "__VITE_PUBLIC_ASSET__6064c22b__"